export const products = [
  {
    id: "p1",
    name: "Nike Air Force 1 Low",
    brand: 'nike',
    color: "White",
    price: 82,
    gender: "male",
    image:
      "https://i.postimg.cc/vmgYfqNJ/custom-nike-air-force-1-low-by-you-shoe-removebg-preview.png",
  },
  {
    id: "p2",
    name: "Adidas Yeezy Boost 350",
    brand: 'adidas',
    color: "V2 Bone",
    price: 250,
    gender: "male",
    image:
      "https://ofour.com/wp-content/uploads/2022/03/adidas-Yeezy-Boost-350-V2-Bone.jpg",
  },
  {
    id: "p3",
    name: "Nike Dunk High",
    brand: 'nike',
    color: "Panda",
    price: 166,
    gender: "male",
    image:
      "https://i.postimg.cc/XqZkb0H2/dunks-panda-removebg-preview.png",
  },
  {
    id: "p4",
    name: "Jordan 11 Retro",
    brand: 'jordan',
    color: "Cool Grey",
    price: 213,
    gender: "male",
    image:
      "https://i.postimg.cc/xjW41svk/air-jordan-11-retro-cool-grey-2021-CT8012-005-1-1350x1350-removebg-preview.png",
  },
  {
    id: "p5",
    name: "Nike Dunk Low",
    brand: 'nike',
    color: "Green Glow",
    price: 208,
    gender: "female",
    image:
      "https://i.postimg.cc/R0DTbFG3/nike-dunk-low-sneakers-green-glow-white-colorway-price-release-date-0-removebg-preview.png",
  },
  {
    id: "p6",
    name: "Nike Dunk High",
    brand: 'nike',
    color: "Pink Prime",
    price: 144,
    gender: "female",
    image:
      "https://cdn.shopify.com/s/files/1/0255/9429/8467/products/nike-dunk-high-pink-prime-w-DD1869-110_1_1200x1200.png?v=1643813459",
  },
  {
    id: "p7",
    name: "Adidas Super Sleek",
    brand: 'adidas',
    color: "Ivy Park",
    price: 59,
    gender: "female",
    image:
      "https://i.postimg.cc/sXW56Jv8/1-46-removebg-preview.png",
  },
  {
    id: "p8",
    name: "Adidas Ultra Boost 21",
    brand: 'adidas',
    color: "Ice Purple",
    price: 96,
    gender: "female",
    image:
      "https://i.postimg.cc/4yds4WV2/Ultraboost-21-Shoes-Purple-S23843-06-standard-removebg-preview.png",
  },
  {
    id: "p9",
    name: "Jordan 5 Retro",
    brand: 'jordan',
    color: "Jade Horizon",
    price: 193,
    gender: "male",
    image:
      "https://i.postimg.cc/vmgYfqNJ/custom-nike-air-force-1-low-by-you-shoe-removebg-preview.png",
  },
  {
    id: "p10",
    name: "Adidas Yeezy Boost 350",
    brand: 'adidas',
    color: "Light",
    price: 289,
    gender: "male",
    image:
      "https://cdn.shopify.com/s/files/1/0255/9429/8467/products/adidas-yeezy-boost-350-v2-light-GY3438_1_ff5ad5e2-b86c-4bca-ad98-741a1f399172_900x900.png?v=1630328136",
  },
  {
    id: "p11",
    name: "Nike Dunk Low",
    brand: 'nike',
    color: "Safari Mix",
    price: 144,
    gender: "female",
    image:
      "https://ofour.com/wp-content/uploads/2022/03/6-6.jpg",
  },
  {
    id: "p12",
    name: "New Balance 550",
    brand: 'newbalance',
    color: "Au Lait",
    price: 177,
    gender: "female",
    image:
      "https://i.postimg.cc/gcgcMztW/newbalance-removebg-preview.png",
  },
  {
    id: "p13",
    name: "New Balance 550",
    brand: 'newbalance',
    color: "Aime Leon",
    price: 343,
    gender: "male",
    image:
      "https://cdn.filestackcontent.com/VtvU8mEbTxaGqSSbwY2i",
  },
  {
    id: "p14",
    name: "New Balance 550",
    brand: 'newbalance',
    color: "Syracuse",
    price: 114,
    gender: "male",
    image:
      "https://cdn.shopify.com/s/files/1/0727/7851/products/NB550SYRACUSEaBB550HG1_600x.jpg?v=1643141072",
  },
  {
    id: "p15",
    name: "Jordan 1 Retro",
    brand: 'jordan',
    color: "Tie Dye",
    price: 175,
    gender: "female",
    image:
      "https://sneakers123.s3.amazonaws.com/release/333956/jordan-1-retro-tie-dye-cu0450-100.jpg",
  },
  {
    id: "p16",
    name: "Jordan 4 Retro",
    brand: 'jordan',
    color: "Shimmer",
    price: 314,
    gender: "female",
    image:
      "http://cdn.shopify.com/s/files/1/0602/1896/6247/products/air-jordan-4-retro-shimmer-w-DJ0675-200_1_900x900_317c34c4-b528-48da-b369-18ffc1728fa9_1200x1200.png?v=1640228427",
  },
  {
    id: "p17",
    name: "Adidas Sambarose",
    brand: 'adidas',
    color: "Valentine",
    price: 88,
    gender: "female",
    image:
      "https://cdn.shopify.com/s/files/1/0603/3031/1875/products/main-square_48cd1468-3bb8-469e-b350-136e59547e2b_765x.jpg?v=1648805917",
  },
  {
    id: "p18",
    name: "Nike Dunk Low",
    brand: 'nike',
    color: "Two Tone Grey",
    price: 180,
    gender: "male",
    image:
      "https://i.postimg.cc/N0C562Dn/Nike-dunk-low-two-tone-removebg-preview.png",
  },
  {
    id: "p19",
    name: "Adidas Ultra Boost",
    brand: 'adidas',
    color: "Magic Grey",
    price: 180,
    gender: "male",
    image:
      "https://i.postimg.cc/9FgKjWxh/188392-removebg-preview.png",
  },


];
